import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NATIONALITY_FEATURE_KEY, nationalityAdapter, NationalityState } from './nationality.reducer';

// Lookup the 'Nationality' feature state managed by NgRx
export const getNationalityState = createFeatureSelector<NationalityState>(NATIONALITY_FEATURE_KEY);

const { selectAll, selectEntities } = nationalityAdapter.getSelectors();

export const getNationalityLoaded = createSelector(getNationalityState, (state: NationalityState) => state.loaded);

export const getNationalityError = createSelector(getNationalityState, (state: NationalityState) => state.error);

export const getAllNationality = createSelector(getNationalityState, (state: NationalityState) => selectAll(state));

export const getNationalityEntities = createSelector(getNationalityState, (state: NationalityState) => selectEntities(state));

export const getNationalitySingpassMap = createSelector(getNationalityState, (state: NationalityState) => state.singpassMap);
